import styled from "styled-components";

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  opacity: 0.7;
  padding: 0.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  &:hover {
    transform: scale(1.1);
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.05);
  }

  &.active {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.05);
    box-shadow: 0 0 0 1px var(--primary-color, #f9c0f5);
  }
  
  /* Make flags slightly smaller in footer context */
  img {
    width: 20px;
    height: 20px;
  }
  
  @media only screen and (max-width: 768px) {
    width: 26px;
    height: 26px;
    
    img {
      width: 18px;
      height: 18px;
    }
  }
  
  @media only screen and (max-width: 480px) {
    width: 24px;
    height: 24px;
    
    img {
      width: 16px;
      height: 16px;
    }
  }
`;